module.exports = __webpack_public_path__ + "static/media/flying_windows_100.e8fb0ca2.ico";